import { GetTokenSilentlyOptions } from '@auth0/auth0-react';
import { getCookieValue } from '~/helpers/utils';

let getAccessTokenSilently: (
  options?: GetTokenSilentlyOptions | undefined
) => Promise<string> = async () => {
  throw new Error('getAccessTokenSilently function not set');
};

export const accessToken = {
  get: async () => {
    try {
      const token = await getAccessTokenSilently();
      if (token) return token;
    } catch {
      // Auth provider not available (e.g. manual/unauthenticated flow)
    }
    return getCookieValue('publicToken') ?? undefined;
  },
  set: (func: () => Promise<string>) => (getAccessTokenSilently = func),
};

export const AUTH0_TOKEN = {
  EMAIL: 'https://mypages/email',
  SSN: 'https://mypages/ssn',
  MARKET: 'https://mypages/market',
  CLIENT_ID: 'https://onboarding/clientId',
  USER_CODE: 'https://onboarding/userCode',
  DATE_OF_BIRTH: 'https://onboarding/dateOfBirth',
};

export const COGNITO_TOKEN = {
  USER_CODE: 'custom:user_code',
  MARKET: 'custom:market',
};

export const SVC_ONBOARDING_TOKEN = {
  CLIENT_ID: 'sub',
  COUNTRY_CODE: 'countryCode',
  APPLICATION_UUID: 'applicationUuid',
};
